export const VENATUS_DESKTOP_SIDE_RAIL = "65cb1aa86ea70577f87fcc32"
export const VENATUS_DESKTOP_MULTISIZE_LEADERBOARD = "65cb1abef1070e4763f1b1cc"
export const VENATUS_DESKTOP_LEADERBOARD = "65cb1b096ea70577f87fcc34"
export const VENATUS_DESKTOP_INCONTENT = "65cb1b1cf1070e4763f1b1ce"

export const VENATUS_MOBILE_LEADERBOARD = "65cb1b3bf1070e4763f1b1d0"
export const VENATUS_MOBILE_INCONTENT = "65cb1b5f6ea70577f87fcc36"

export const VENATUS_RICH_MEDIA_WITH_STICKY_VERTICAL = "65e1a2359105a208f7635fdd"
export const VENATUS_RICH_MEDIA = "65cb1bd7f1070e4763f1b1d6"



// WEBPACK FOOTER //
// ./src/components/utilities/constants.js